import { AppThunk } from '../../../store/rootReducer';
import { CREATE_WAVE } from '../../analytics/analytics.constants';
import { trackCreateWave } from '../../analytics/thunks/track-create-wave.thunk';
import { smallestStripSelector } from '../../navigation/selectors/navigation.selectors';
import { createModeSelector } from '../selectors/create.selectors';
import { medianDurationsSelector } from '../selectors/wave.selectors';
import { Wave, WaveId, WaveLink, WaveType } from '../types/wave.type';
import { CreateMode } from '../utils/create.utils';
import { generateWaveId } from '../utils/wave.util';
import { addWave } from './add-wave.thunk';

interface CreateWaveOptions {
  id?: WaveId;
  link?: WaveLink;
}
export const createQrsWave =
  (timestamp: number): AppThunk =>
  async (dispatch, getState) => {
    const createMode = createModeSelector(getState());
    const smallestStrip = smallestStripSelector(getState());
    let startingOnset = 0;
    if (smallestStrip != null) {
      startingOnset = smallestStrip.onset;
    }

    const addNewWave = (
      timestamp: number,
      type: WaveType,
      { id = generateWaveId(), link }: CreateWaveOptions = {},
    ) => {
      const medianDuration = medianDurationsSelector(timestamp)(getState());

      const wave: Wave = {
        id,
        onset: timestamp - medianDuration[type] / 2 - startingOnset,
        offset: timestamp + medianDuration[type] / 2 - startingOnset,
        tags: ['manual'],
        type,
        background: false,
        link,
      };

      dispatch(addWave(wave));
    };

    switch (createMode) {
      case CreateMode.P:
        dispatch(trackCreateWave(CREATE_WAVE, 'P'));
        addNewWave(timestamp, 'P');
        break;
      case CreateMode.QRS:
        dispatch(trackCreateWave(CREATE_WAVE, 'QRS'));
        addNewWave(timestamp, 'QRS');
        break;
      case CreateMode.QRST: {
        dispatch(trackCreateWave(CREATE_WAVE, 'QRS+T'));
        const waveId1 = generateWaveId();
        const waveId2 = generateWaveId();
        addNewWave(timestamp, 'QRS', {
          id: waveId1,
          link: {
            waveId: waveId2,
            type: 'offset',
          },
        });
        const medianDurations = medianDurationsSelector(timestamp)(getState());
        const qrsWaveOffset = timestamp + medianDurations.QRS / 2;
        const tWaveMiddle = qrsWaveOffset + medianDurations.T / 2;
        // We make the end of the QRS wave match the start of the T wave

        addNewWave(tWaveMiddle, 'T', {
          id: waveId2,
          link: {
            waveId: waveId1,
            type: 'onset',
          },
        });
        break;
      }
      case CreateMode.T:
        dispatch(trackCreateWave(CREATE_WAVE, 'T'));
        addNewWave(timestamp, 'T');
        break;
    }
  };
